import { Flex, Link, Text, useDisclosure } from '@chakra-ui/react';
import { ReactComponent as UpgradeIcon } from 'assets/icons/crown_upgrade_fill.svg';
import BrandKitImage from 'assets/images/brand_kit.png';
import { UPGRADE_REDIRECT_BIZ_LINK } from 'constants/links';
import { CLICK_ON_PAID_FEATURE, UPGRADE } from 'constants/mixpanel';
import { useChameleon } from 'libs/third-party/Chameleon';
import { Mixpanel } from 'libs/third-party/Mixpanel/mixpanel';
import { CommonGatedUpgradeModal } from 'modules/Editor/components/Modals/CommonGatedUpgradeModal';
import { ModalUpgradeTypeEnum } from 'modules/Editor/components/Modals/CommonGatedUpgradeModal.types';
import { UserTypes } from 'modules/User';
import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { setAnalyticsUpgradeFeatureProp } from 'utils/sessionStorage';

interface BusinessUpgradeButtonProps {
  mixpanelFeature?: string;
}

export const BusinessUpgradeButton = ({
  mixpanelFeature = UPGRADE.feature.Brandkit,
}: BusinessUpgradeButtonProps): ReactElement => {
  const { t } = useTranslation('common_navbar', { useSuspense: false });
  const { trackChameleon } = useChameleon();
  const { isOpen: isUpgradeModal, onOpen: onOpenUpgradeModal, onClose: onCloseUpgradeModal } = useDisclosure();

  const clickUpgradeHandler = (featureProp: string) => {
    // Set mixpanel_feature session storage item used by `Analytics: Upgrade` event
    setAnalyticsUpgradeFeatureProp(featureProp);
    Mixpanel.track(UPGRADE.eventName, {
      Feature: featureProp,
    });
    trackChameleon(UPGRADE.eventName);
    window.open(UPGRADE_REDIRECT_BIZ_LINK, '_self');
  };

  const onClickUpgradeModal = () => {
    onOpenUpgradeModal();
    Mixpanel.track(CLICK_ON_PAID_FEATURE.eventName, {
      Feature: UPGRADE.feature.Brandkit,
      plan: UserTypes.Business,
    });
  };

  return (
    <Flex marginBottom={3} flexWrap='wrap' alignItems='center'>
      <CommonGatedUpgradeModal
        isOpen={isUpgradeModal}
        onClose={onCloseUpgradeModal}
        onClickUpgrade={clickUpgradeHandler.bind(null, mixpanelFeature)}
        upgradePlan={UserTypes.Business}
        modalImg={BrandKitImage}
        modalType={ModalUpgradeTypeEnum.BrandKit}
      />
      <UpgradeIcon color='var(--vg-colors-upgrade-700)' />
      <Link
        fontSize='xs'
        color='upgrade.700'
        fontWeight='semibold'
        ml='1'
        lineHeight='1.2'
        onClick={onClickUpgradeModal}
        as='button'
      >
        {t('modals.download.upgrade-business')}
      </Link>
      <Text fontSize='xs' fontWeight='medium' ml='1' lineHeight='1.2'>
        {t('modals.toUseBrandKit')}
      </Text>
    </Flex>
  );
};
